import {
  Edit as EditIcon,
  Eye as ViewIcon,
  Trash2 as Trash2Icon,
} from 'react-feather'
import { reverse } from 'named-urls'
import { useHistory } from 'react-router-dom'
import { Button, Typography } from '@material-ui/core'

import {
  MenuButton,
  Permitted,
  BaseDialog as ModalConfirmDestroy,
} from 'components'
import { TableRow, TableCell } from 'components/Table'

import { useSnackbar } from 'hooks'

import constants from 'constants/index'
import { routes } from 'Routes'
import { useState } from 'react'
import * as service from 'service'
import helpers from 'helpers'

const SSOCorporateGroupTableRow = ({ ssoCorporateGroup, refresh }) => {
  const [openModalConfirmDestroy, setOpenModalConfirmDestroy] = useState(false)
  const [loading, setLoading] = useState(false)

  const history = useHistory()
  const snackbar = useSnackbar()

  const navigate = (route, ssoCorporateGroupId) => {
    if (route === 'show') {
      return history.push(
        reverse(routes.ssoCorporateGroups.show, {
          ssoCorporateGroupId,
        }),
      )
    }

    history.push(
      reverse(routes.ssoCorporateGroups.edit, {
        ssoCorporateGroupId,
      }),
    )
  }

  const handleDestroySSOCorporateGroup = async () => {
    try {
      setLoading(true)
      await service.dponet.ssoCorporateGroups.destroy({
        ssoCorporateGroupId: ssoCorporateGroup?.id,
      })
      setOpenModalConfirmDestroy(false)
      snackbar.open({
        message: 'Organização SSO-SAML deletada com sucesso',
        variant: 'success',
      })
      refresh()
    } catch (error) {
      console.error(error)
      snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error ||
            'Erro ao deletar a organização com login SSO-SAML',
        ),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleOpenModalConfirmDestroy = () => {
    setOpenModalConfirmDestroy(true)
  }

  return (
    <TableRow key={ssoCorporateGroup?.id}>
      <TableCell width="10%">{ssoCorporateGroup?.id}</TableCell>
      <TableCell width="30%" align="left">
        {ssoCorporateGroup?.name}
      </TableCell>
      <TableCell width="15%" align="left">
        {ssoCorporateGroup?.domain}
      </TableCell>
      <TableCell width="15%" align="left">
        {ssoCorporateGroup?.platform === 'dponet'
          ? 'Dponet'
          : ssoCorporateGroup?.platform === 'advisor'
          ? 'Advisor'
          : 'DPOnet e Advisor'}
      </TableCell>
      <TableCell width="10%" align="left">
        {ssoCorporateGroup?.scim ? 'Sim' : 'Não'}
      </TableCell>
      <TableCell width="20%" align="left">
        {ssoCorporateGroup?.samlProvider === 'zitadel'
          ? 'DPOnet SSO'
          : 'SSOready'}
      </TableCell>
      <Permitted
        someTags={[
          constants.permissions.SSO_CORPORATE_GROUP.SHOW,
          constants.permissions.SSO_CORPORATE_GROUP.CREATE,
          constants.permissions.SSO_CORPORATE_GROUP.EDIT,
        ]}
      >
        <TableCell disableTooltip align="center">
          <MenuButton>
            <Permitted tag={constants.permissions.SSO_CORPORATE_GROUP.EDIT}>
              <Button
                startIcon={<EditIcon />}
                onClick={() => {
                  navigate('edit', ssoCorporateGroup?.id)
                }}
              >
                EDITAR
              </Button>
            </Permitted>
            <Permitted
              someTags={[
                constants.permissions.SSO_CORPORATE_GROUP.SHOW,
                constants.permissions.SSO_CORPORATE_GROUP.CREATE,
                constants.permissions.SSO_CORPORATE_GROUP.EDIT,
              ]}
            >
              <Button
                startIcon={<ViewIcon />}
                onClick={() => {
                  navigate('show', ssoCorporateGroup?.id)
                }}
              >
                VISUALIZAR
              </Button>
            </Permitted>
            <Permitted
              someTags={[
                constants.permissions.SSO_CORPORATE_GROUP.DESTROY,
                constants.permissions.SSO_CORPORATE_GROUP.EDIT,
              ]}
            >
              <Button
                startIcon={<Trash2Icon />}
                onClick={handleOpenModalConfirmDestroy}
                disabled={loading}
              >
                Deletar
              </Button>
            </Permitted>
          </MenuButton>
        </TableCell>
      </Permitted>
      <ModalConfirmDestroy
        open={openModalConfirmDestroy}
        title="Confirme a exclusão"
        actionButton={handleDestroySSOCorporateGroup}
        actionButtonText="Excluir"
        setOpen={setOpenModalConfirmDestroy}
        closeButtonText="Cancelar"
      >
        <Typography>
          Tem certeza que deseja deletar essa Organização com Login SSO-SAML?
        </Typography>
      </ModalConfirmDestroy>
    </TableRow>
  )
}

export default SSOCorporateGroupTableRow
